/* eslint-disable @typescript-eslint/no-shadow */
import { FC, useRef } from 'react';

type ItemSliderProps = {
  children: any;
  index?: number;
  itemWidth?: number;
  itemGap?: number;
};

const ItemSlider: FC<ItemSliderProps> = ({
  children,
  index = 0,
  itemWidth = 200,
}) => {
  const sliderWindow = useRef<HTMLDivElement>();
  const slide = useRef<HTMLDivElement>();

  if (!children && children.length === 0) return <></>;

  const rawPos = -(Math.ceil(itemWidth) * index);

  const position = rawPos; // Math.max(rawPos, -rawWidth + size.width);

  return (
    <>
      <div ref={sliderWindow} className="relative h-full">
        <div
          ref={slide}
          className={`flex flex-row w-min relative transition-transform duration-1000 ease-in-out`}
          style={{
            transform: `translate(${position}px)`,
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
};

export default ItemSlider;
